import { styled } from 'parkdepot-shared/theme'

export const TextSection = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 700,
    color: $theme.colors.primary
}))

export const Container = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.blue50,
    display: 'flex',
    alignItems: 'center',
    borderRadius: $theme.borders.radius400,
    gap: $theme.sizing.scale500,
    padding: `${$theme.sizing.scale600} ${$theme.sizing.scale800}`,
    margin: `${$theme.sizing.scale600} 0`
}))
